import { type MatrixEvent, type PollStartEventContent } from "matrix-js-sdk/src/matrix";
import { InvalidEventError } from "matrix-js-sdk/src/extensible_events_v1/InvalidEventError";
import { PollStartEvent } from "matrix-js-sdk/src/extensible_events_v1/PollStartEvent";

import { type Preview } from "./Preview";
import { type TagID } from "../../room-list-v3/skip-list/tag";
import { _t, sanitizeForTranslation } from "../../../languageHandler";
import { getSenderName, isSelf, shouldPrefixMessagesIn } from "./utils";

export class PollStartEventPreview implements Preview {
    public getTextFor(event: MatrixEvent, tagId?: TagID, isThread?: boolean): string | null {
        let eventContent = event.getContent();

        if (event.isRelation("m.replace")) {
            // It's an edit, generate the preview on the new text
            eventContent = event.getContent()["m.new_content"];
        }

        // Check we have the information we need, and bail out if not
        if (!eventContent) {
            return null;
        }

        try {
            const poll = new PollStartEvent({
                type: event.getType(),
                content: eventContent as PollStartEventContent,
            });

            let question = poll.question.text.trim();
            question = sanitizeForTranslation(question);

            // if (isThread || isSelf(event) || !shouldPrefixMessagesIn(event.getRoomId()!, tagId)) {
            //     return question;
            // } else {
            //     return _t("event_preview.m_text", { senderName: getSenderName(event), message: question });
            // }

            const roomId: string | undefined = event.getRoomId();

            // DTH: Chat 1:1
            // Se è un messaggio proprio, mostra "Tu: messaggio"
            // Se è un messaggio ricevuto, mostra solo "messaggio" senza prefisso del mittente
            // DTH: Chat gruppo
            // Se è un messaggio proprio, mostra "Tu: messaggio"
            // Se è un messaggio ricevuto, mostra "NomeMittente: messaggio"
            const isSelfMessage = isSelf(event);
            const sender: string = isSelfMessage ?
                _t("event_preview.m_text_you") :
                getSenderName(event);
            // DTH: Mostra il prefisso del mittente se è un messaggio proprio o se la stanza non è una chat 1:1. 
            // Per i messaggi ricevuti in una chat 1:1, non mostrare il prefisso.
            const showSender: boolean = isSelfMessage || (!!roomId && shouldPrefixMessagesIn(roomId, tagId));

            const message = `${_t("event_preview.prefix.poll")}: ${question}`;

            // DTH: Mostra il prefisso del mittente se è true, altrimenti solo il messaggio
            return showSender ?
                _t("event_preview.m_text", { senderName: sender, message }) :
                message;
        } catch (e) {
            if (e instanceof InvalidEventError) {
                return null;
            }
            throw e; // re-throw unknown errors
        }
    }
}
